// extracted by mini-css-extract-plugin
export default {"primary":"DuplicateCell_primary__9NIT0","name":"DuplicateCell_name__w3dCI","secondary":"DuplicateCell_secondary__uowju"};